import { CurrentClub, Player } from '../squad-database/api-types';

export type NewSquad = SquadPlayer[];

export interface SquadPlayer extends Player {
  activeCurrentClub: CurrentClub | null;
}

export interface Squad {
  squad?: Player[] | null;
  year: string;
}

export interface TeamConfig {
  abbrv: string;
  configLeagueName: string;
  name: string;
  currentSeason: number;
}

export enum FilterType {
  MultipleValues = 'MultipleValues',
  SingleValue = 'SingleValue',
  FreeText = 'FreeText',
}

export enum Field {
  League = 'league',
  Team = 'team',
  PlayerName = 'playerName',
  PlayerImage = 'playerImage',
  PlayerSmcId = 'playerSmcId',
  PlayerForzasysId = 'playerForzasysId',
  PlayerEfId = 'playerEfId',
  PlayerEsId = 'playerEsId',
  PlayerShirtNumber = 'playerShirtNumber',
  PlayerFogisId = 'playerFogisId',
  PlayerOptaId = 'playerOptaId',
  PlayerPosition = 'playerPosition',
  PlayerNationality = 'playerNationality',
  SearchContent = 'searchContent',
}
export enum Operation {
  EQ = 'eq',
  CS = 'cs',
  NEQ = 'neq',
  NCS = 'ncs',
}

export interface Filter {
  field: Field;
  operation: Operation;
  value: string[];
  filterType: FilterType;
}

export interface FilterOption {
  label: string;
  subLabel?: string;
  subImage?: string | null;
  value: string;
  valueLabel?: string;
  image?: string;
  operation: Operation;
}
